import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonTypeEnum} from '../../enums/skeleton';

export const RowsSkeleton: ISkeleton[] = [
  /*{
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    classes: 'mb-sm tw-flex tw-justify-between',
    items: [
      {
        type: SkeletonTypeEnum.TEXT,
        style: 'width: 350px;',
        rows: 0,
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 200px; height: 40px;',
      }
    ]
  },*/
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mb-sm',
    style: 'width: 100%; height: 40px;'
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mb-sm',
    style: 'width: 100%; height: 40px;'
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mb-sm',
    style: 'width: 100%; height: 40px;'
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mb-sm',
    style: 'width: 100%; height: 40px;'
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mb-sm',
    style: 'width: 100%; height: 40px;'
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mb-sm',
    style: 'width: 100%; height: 40px;'
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mb-sm',
    style: 'width: 100%; height: 40px;'
  },
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    classes: 'mb-sm',
    style: 'width: 100%; height: 40px;'
  }
];
